module.exports = __webpack_public_path__ + "img/location-benefit.21da8dd9.svg";